import * as React from 'react'
import styled from '../../../common/src/components/styled'
import { Fonts } from '../../../common/src/constants'
import { isMorning } from '../../../common/src/date'

const Root = styled.div({
  fontSize: 48,
  fontFamily: Fonts.sansHeader,
  fontWeight: 'bolder',
})

interface GreetingProps {
  now: Date
  agentFirstName?: string | null
}

const Greeting = (props: GreetingProps) => {
  const { now, agentFirstName } = props
  const greeting = `Good ${isMorning(now) ? 'morning' : 'afternoon'}`

  return (
    <Root>
      🌴 {greeting}
      {agentFirstName && `, ${agentFirstName}`}.
    </Root>
  )
}

export default Greeting
